<template>
  <div id="view-users-container">
    <div id="view-users">
    <div class="container is-fluid">
        <div class="columns users-toolbar">
          <div class="column is-10">
            <p class="control has-icon search-container">
              <input class="input is-medium" type="text" placeholder="Procurar Utilizadores" v-model="searchString">
              <i class="fa fa-search"></i>
            </p>
          </div>
          <div class="column is-2"><user-new></user-new></div>
        </div>
      </div>
      <div class="container is-fluid">
		    <div class="flexbox-grid">
          <user-card v-for="user in users" :user="user"></user-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserCard from './UserCard'
  import UserSearch from './UserSearch'
  import UserNew from './UserNew'
  
  export default {
    components: {
      UserCard,
      UserSearch,
      UserNew
    },

    data () {
      return {
        searchString: ''
      }
    },

    mounted () {
      this.getUserList()
    },

    computed: {
      users () {
        var searchString = this.searchString
        var filteredList = null
        if (this.$store.state.user.list) {
          filteredList = this.$store.state.user.list.filter(function (val) {
            return val.name.toLowerCase().includes(searchString.toLowerCase())
          })
        }
        return filteredList
      },

      currentEvent () {
        return window.store.state.event.nextEvent
      }
    },

    methods: {
      getUserList () {
        this.$store.dispatch('getUserList')
      }
    },

    watch: {
      currentEvent: function (val) {
        if (val === 'update-user-list') {
          this.getUserList()
        }
      }
    }
  }
</script>

<style lang="scss">
  .users-toolbar {
    margin-bottom: 10px !important;
  }

  .flexbox-grid {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
</style>


// WEBPACK FOOTER //
// index.vue?28b5bf07